define([
	"dojo/_base/declare",
	"./SampleActual",
	"./ActualGapMixin"
], function(declare,SampleActual,ActualGapMixin) {

	return declare([ActualGapMixin, SampleActual], {
		highlightSetting: "sizeChartHighlightDeltaOutOfTolerance",

		_getActual: function(/*Context*/ctx) {
			// summary: return actual value
			return ctx.getNode().DimensionActuals[ctx.keyValue];
		},
		
		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return value since it is already the difference
			return value;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			return this._getValueGap(ctx);
		}
	});
});